import React from 'react';
import FormikSearchDropdown from 'src/components/formik/FormikSearchDropdown/FormikSearchDropdown';
import { SEARCH_RECORD_PAGE_LIMIT } from 'src/constants/CommonConstants';
import PropTypes from 'prop-types';
import { customerSearchAPI } from 'src/api/CustomerApi';

const CustomerDropDown = ({ value, name, onChange }) => (
    <FormikSearchDropdown
        name={name}
        placeholder="Select Customer"
        displayKeyPath={[
            'firstName',
            'lastName',
            'phone',
            'email',
        ]}
        valueKeyPath="_id"
        defaultValueFetchByKeyPath="_id"
        whereClauseKeysPaths={[
            'firstName',
            'lastName',
            'phone',
            'email',
        ]}
        api={customerSearchAPI}
        apiCallAddonData={{
            pageLength: 1000,
        }}
        value={value}
        onChange={onChange}
    />
);

CustomerDropDown.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    value: PropTypes.any,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func,
};

CustomerDropDown.defaultProps = {
    value: '',
    onChange: () => { },
};

export default CustomerDropDown;
